import Cabinet from "./Cabinet";
import "./style.css";
export default Cabinet;
